import { createAsyncThunk } from '@reduxjs/toolkit';
import schedulerTasksApi from '../../../api/schedulerTasksApi';

// ---------------------------------------------------------------------

const REDUCER_NAME = 'schedulerTasks';

export const GetSchedulerTasks = createAsyncThunk(`${REDUCER_NAME}/getSchedulerTasks`, async (__, thunkAPI) => {
  const res = await schedulerTasksApi.getAll();

  if (res.status === 200) {
    return res.data;
  }

  return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
});

export const GetSchedulerTaskHistory = createAsyncThunk(
  `${REDUCER_NAME}/getSchedulerTaskHistory`,
  async (__, thunkAPI) => {
    const res = await schedulerTasksApi.getHistory();

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const ClearSchedulerTaskHistory = createAsyncThunk(
  `${REDUCER_NAME}/clearSchedulerTaskHistory`,
  async (__, thunkAPI) => {
    const res = await schedulerTasksApi.clearHistory();

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const GetSchedulerTaskById = createAsyncThunk<any, string>(
  `${REDUCER_NAME}/getSchedulerTaskById`,
  async (id, thunkAPI) => {
    const res = await schedulerTasksApi.getById(id);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const CreateSchedulerTask = createAsyncThunk<any, any>(
  `${REDUCER_NAME}/createSchedulerTask`,
  async (data, thunkAPI) => {
    const res = await schedulerTasksApi.create(data);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const UpdateSchedulerTask = createAsyncThunk<any, any>(
  `${REDUCER_NAME}/updateSchedulerTask`,
  async ({ id, data }, thunkAPI) => {
    const res = await schedulerTasksApi.update(id, data);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const DeleteSchedulerTask = createAsyncThunk<any, string>(
  `${REDUCER_NAME}/deleteSchedulerTask`,
  async (id, thunkAPI) => {
    const res = await schedulerTasksApi.delete(id);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const ChangeInactiveStatusSchedulerTask = createAsyncThunk<any, string>(
  `${REDUCER_NAME}/changeInactiveStatusSchedulerTask`,
  async (id, thunkAPI) => {
    const res = await schedulerTasksApi.changeInactiveStatus(id);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const ClearNextRunAtSchedulerTask = createAsyncThunk<any, string>(
  `${REDUCER_NAME}/clearNextRunAtSchedulerTask`,
  async (id, thunkAPI) => {
    const res = await schedulerTasksApi.clearNextRunAt(id);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);
